import axios from 'axios';
import _ from 'lodash';
import { NETWORK, REDIRECT_SUFFIX } from '../../../../framework/App/AppConstants';
import { redirectFlowAction } from '../../../../framework/store/RedirectFlow/RedirectFlowActions';
import { spinnerOpen, spinnerClose } from '../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../../config/DEConstants';
import { SET_CYCO_FINANCING_OPTION, SET_CYCO_FAILED_VALIDATION } from './CycoPageConstants';
import { SubmissionError } from 'redux-form';
import { scrollToTop } from '../../../../framework/App/SkeletonPage/SkeletonPageActions';
import { setServerData } from '../../../../framework/store/ServerData/ServerDataActions';

export const setCycoFinancingOption = financingOption => ({ type: SET_CYCO_FINANCING_OPTION, payload: financingOption });

export const setCycoFailedValidation = validationErrors => ({ type: SET_CYCO_FAILED_VALIDATION, payload: validationErrors });

export const submitCycoApiAction = function(formValues = {}) {
    return function(dispatch, getState) {
        const { serverData = {} } = getState();
        const { _csrf = '' } = serverData;

        const data = {
            cycoSelectedCode: formValues.offer
        };

        dispatch(spinnerOpen());
        return axios
            .request({
                method: 'post',
                url: 'cycopageapi',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            }).then(response => {
                const validationErrors = _.get(response, 'data.data.validation.errors');
                if (!_.isEmpty(validationErrors)) {
                    capeLog && capeLog(`Cyco submit failed validation :${JSON.stringify(validationErrors, 0, 2)}`);
                    dispatch(setCycoFailedValidation(validationErrors));
                    dispatch(scrollToTop());
                    throw new SubmissionError(validationErrors);
                } else {
                    dispatch(setCycoFinancingOption(_.get(response, 'data.data')));
                    dispatch(setServerData({financingDetails: _.get(response, 'data.data')}));
                    dispatch(push(PAGE_NAME.APPLY_PAGE));
                    dispatch(spinnerClose());
                }
            }).catch(err => {
                // handle error
                dispatch(spinnerClose());

                if (err && err.name === 'SubmissionError') {
                    return Promise.reject(err);
                }
            });
    };
};
